/*global VeloxGridAndFormController, VeloxWebView, veloxScriptLoader, VeloxFormController, moment*/
var Mustache = require("mustache");
var uuid = require("uuid");
var rho = require("rho");
var bluetooth = require("./bluetooth");
var Diag = require("../../util/diag") ;
var BLOCKS = require("../../util/diagBlocks") ;
var PRODUCTS = require("../../util/products") ;
var disinfExt = require("../../extensions/disinf") ;
var trTemplate = {
    "fr-FR" : require("../../views/reportTemplate/locales/fr-FR/translation.json"),
    "fr" : require("../../views/reportTemplate/locales/fr-FR/translation.json"),
    "es-ES" : require("../../views/reportTemplate/locales/es-ES/translation.json"),
    "en-GB" : require("../../views/reportTemplate/locales/en-GB/translation.json"),
    "de-DE" : require("../../views/reportTemplate/locales/de-DE/translation.json"),
    "de" : require("../../views/reportTemplate/locales/de-DE/translation.json")
} ;

var diagController = new VeloxGridAndFormController("diag", {
    grid : {
        directory: "views/diag",
        name: "diagGrid"
    },
    form : {
        buttonsHTML: "<!--no button-->",
        directory: "views/diag",
        name: "diagForm",
        defaultData : {
            p_regulation: "NO",
            d_pool_or_spa: "POOL",
            d_date : new Date()
        }
    }
});

/**
 * Handle the different cases of data that can be receive :
 *  - diag id (from diag history)
 *  - customer id (create new diag for a customer)
 */
diagController.formController.prepareDataOnEnter = function(data, callback){
    this.api.api.multiread({ 
        reseller_settings : {
            searchFirst: {}
        },
        domain : {
            searchFirst: {}
        },
    }, function(err, reads){
        if(err){ return callback(err) ;}

        VeloxFormController.prototype.prepareDataOnEnter.call(this,data, function(err, dataRead){
            if(err){ return callback(err); }
            if(!dataRead){ throw "Can't get diag "+data }

            if(data){
                this.mode = "modify"
            }

            dataRead.d_diag_price = reads.reseller_settings?reads.reseller_settings.rs_diag_price:"" ;
            if(reads.domain && reads.domain.do_default_catalog){
                dataRead.d_catalog = reads.domain.do_default_catalog ;
            }else if(reads.domain && reads.domain.do_active_catalogs.length === 1){
                dataRead.d_catalog = reads.domain.do_active_catalogs[0] ;
            }
            dataRead.hiddenProducts = {
                BAYROL: [],
                AQUAPURE: [],
            };
            if(reads.reseller_settings && reads.reseller_settings.rs_hidden_products_bayrol){
                reads.reseller_settings.rs_hidden_products_bayrol.forEach((p)=>{
                    dataRead.hiddenProducts.BAYROL.push(p) ;
                }) ;
            }
            if(reads.reseller_settings && reads.reseller_settings.rs_hidden_products_aquapure){
                reads.reseller_settings.rs_hidden_products_aquapure.forEach((p)=>{
                    dataRead.hiddenProducts.AQUAPURE.push(p) ;
                }) ;
            }
            dataRead.possibleCatalogs = (reads.domain && reads.domain.do_active_catalogs)?reads.domain.do_active_catalogs:["BAYROL"] ;
            dataRead.domain = reads.domain;
            callback(null, dataRead) ;
        }.bind(this));
    }.bind(this));
} ;

diagController.formController.onCustomerRemove = function(){
    this.updateRouteData(diagController.formController.viewOptions.route, "") ;
};
diagController.formController.onCustomerOpen = function(){
    this.navigate("/customer/form", {c: this.data.customer.c_id}) ;
};



/**
 * user chose pool or span mode
 */
diagController.formController.onBeforeRender = function(){
    if(this.data.d_pool_or_spa === "POOL"){
        document.getElementById("main").className = document.getElementById("main").className.replace(" spa", "") ;
    }else if(this.data.d_pool_or_spa === "SPA"){
        if(document.getElementById("main").className.indexOf("spa") === -1){
            document.getElementById("main").className += " spa" ;
        }
    }
    if(this.data.customer){
        if(this.data.d_pool_or_spa === "POOL"){
            this.data.p_volume = this.data.customer.pool.p_volume;
            this.data.p_filter = this.data.customer.pool.p_filter;
            this.data.p_extra_installation = this.data.customer.pool.p_extra_installation;
            this.data.p_pool_cover = this.data.customer.pool.p_pool_cover;
            this.data.p_pool_cover_other = this.data.customer.pool.p_pool_cover_other;
            this.data.p_regulation = this.data.customer.pool.p_regulation;
            this.data.p_regulation_other = this.data.customer.pool.p_regulation_other;
            this.data.p_electrolyzer = this.data.customer.pool.p_electrolyzer;
            this.data.p_electrolyzer_other = this.data.customer.pool.p_electrolyzer_other;
            this.data.p_ph_correction = this.data.customer.pool.p_ph_correction;
            this.data.p_alkalinity = this.data.customer.pool.p_alkalinity;
            this.data.p_hardness = this.data.customer.pool.p_hardness;
            this.data.p_disinfectant = this.data.customer.pool.p_disinfectant;
            this.data.p_disinf_shock = this.data.customer.pool.p_disinf_shock;
            this.data.p_disinf_long = this.data.customer.pool.p_disinf_long;
            this.data.p_disinf_salt_rate = this.data.customer.pool.p_disinf_salt_rate;
            this.data.p_algae = this.data.customer.pool.p_algae;
            this.data.p_flocculation = this.data.customer.pool.p_flocculation;
            this.data.p_cleaning = this.data.customer.pool.p_cleaning;
            this.data.p_filter_maintenance = this.data.customer.pool.p_filter_maintenance;
            this.data.p_wintering = this.data.customer.pool.p_wintering;
            this.data.p_advanced_other = this.data.customer.pool.p_advanced_other;            
        }else if(this.data.d_pool_or_spa === "SPA"){
            this.data.s_volume = this.data.customer.spa.s_volume;
            this.data.s_spa_cover = this.data.customer.spa.s_spa_cover;
            this.data.s_spa_cover_other = this.data.customer.spa.s_spa_cover_other;
            this.data.s_filter = this.data.customer.spa.s_filter;
            this.data.s_extra_installation = this.data.customer.spa.s_extra_installation;
            this.data.s_regulation = this.data.customer.spa.s_regulation;
            this.data.s_regulation_other = this.data.customer.spa.s_regulation_other;
            this.data.s_water_balance = this.data.customer.spa.s_water_balance;
            this.data.s_disinfectant = this.data.customer.spa.s_disinfectant;
            this.data.s_disinf_shock = this.data.customer.spa.s_disinf_shock;
            this.data.s_disinf_long = this.data.customer.spa.s_disinf_long;
            this.data.s_disinf_salt_rate = this.data.customer.spa.s_disinf_salt_rate;
            this.data.s_other_product = this.data.customer.spa.s_other_product;
        }
    }
    this.data.hasSpinlab = window.native && window.native.spinlab ;
    this.data.hasBluetooth = !!window.ble ;
} ;

/**
 * Open the grid when user search
 * @param {*} ev 
 */
diagController.formController.onSearch = function(ev){
    var inputSearch = ev.data ;
    this.navigate("~customer/list", {s:inputSearch, d: ".."}) ;
} ;


/**
 * prepare diag data from input
 */
function getInputData(diag){
    var isPool = diag.d_pool_or_spa === "POOL" ;
    var hasElect = false ;
    var shock = [];
    var long = [];
    var disinf = isPool?diag.p_disinfectant:diag.s_disinfectant;
    var disinfFull = disinf;
    
    if(disinf === "CHLORINE"){
        disinf = "CL" ;
        shock = isPool?diag.p_disinf_shock:diag.s_disinf_shock ;
        long = isPool?diag.p_disinf_long:diag.s_disinf_long ;
    }else if(disinf === "BROMINE"){
        disinf = "BR" ;
        shock = isPool?diag.p_disinf_shock:diag.s_disinf_shock ;
        long = isPool?diag.p_disinf_long:diag.s_disinf_long ;
    }else if(disinf === "OXYGEN"){
        disinf = "O2" ;
        shock = isPool?diag.p_disinf_shock:diag.s_disinf_shock ;
        long = isPool?diag.p_disinf_long:diag.s_disinf_long ;
    }else if(disinf === "SALT"){
        disinf = "CL" ;
        disinfFull = "CHLORINE" ;
        shock = isPool?diag.p_disinf_shock:diag.s_disinf_shock ;
        hasElect = true ;
    }
    return {
        measures: {
            alk          : diag.d_alk          ,
            ph           : diag.d_ph           ,
            th           : diag.d_hardness     ,
            clFree       : diag.d_free_cl      ,
            clTotal      : diag.d_total_cl     ,
            br           : diag.d_br           ,
            salt         : diag.d_salt         ,
            salt_disolved: diag.d_salt_disolved,
            cu           : diag.d_cu           ,
            fe           : diag.d_fe           ,
            stab         : diag.d_stab         ,
            temp         : diag.d_temperature  ,
            oxygen       : diag.d_oxygen       ,
            phos         : diag.d_phosphate
        },
        options: {
            mode:               diag.d_mode,
            filterMaint:        diag.d_filter_maint||false,
            cleanLine:          diag.d_clean_line||false,
            startUp:            diag.d_startup||false,
            wintering:          diag.d_wintering||false,
            greenWaterAlgae:    diag.d_green_algae||false,
            greenWaterCrystal:  diag.d_green_water_crystal||false,
            troubleWater:       diag.d_trouble_water||false,
            mousse:             diag.d_mousse||false,
            mark:               diag.d_marks||false,
            markSpa:            diag.d_marks_spa||false,
            textAlg:            diag.d_text_alg||false,
            textTroubled:       diag.d_text_troubled||false,
        },
        pool: {
            poolOrSpa:          diag.d_pool_or_spa.toLowerCase(),
            disinf:             disinf,
            disinfFull:         disinfFull,
            volume:             isPool?diag.p_volume:diag.s_volume,
            saltElect:          hasElect,
            saltRate:           (isPool?diag.p_disinf_salt_rate:diag.s_disinf_salt_rate)||0,
            filter:             (isPool?diag.p_filter:diag.s_filter)||null,
            regul:              isPool&&diag.p_regulation!=="NO",
            regul_other:        (isPool?diag.p_regulation_other:diag.s_regulation_other)||null,
            poolCover:          (isPool?diag.p_pool_cover:diag.s_spa_cover)||null,
            poolCover_other:    (isPool?diag.p_pool_cover_other:diag.s_spa_cover_other)||null,
            shock:              shock||[],
            long:               long||[],
            alg:                (isPool?diag.p_algae:null)||[],
            equip:              (isPool?diag.p_extra_installation:diag.s_extra_installation)||[],
            electrolyzer:       isPool?diag.p_electrolyzer:null,
            electrolyzer_other: isPool?diag.p_electrolyzer_other:null,
        },
        globalNotes:            diag.d_notes
    } ;
}

/**
 * product quantity compute rules
 */
var productQties = {
    "PH_PLUS"               : "xph+",
    "PH_MINUS"               : "xph-",
    "CALCINEX"              : "x1",
    "ALCAPLUS"              : "xtac",
    "SUPERFLOCK_PLUS"      : "x5",
    "NOPHOS"                : "x25",
    "CHLORIKLAR"           : "x2",
    "CHLORIFIX"            : "x14",
    "CHLORYTE"             : "x3",
    "BAYROSHOCK"           : "x11",
    "BAYROSHOCK_LIGHT"     : "x11l",
    "AQUABROME_REGENERATOR": "x10",
    "AQUABROME"             : "x10",
    "CHLORILONG"           : "x8",
    "CHLORILONG_5F"        : "x7",
    "VARITAB"              : "x6",
    "CHLORILONG_BLOC"      : "x18",
    "MULTIBLOC"            : "x19",
    "MULTILONG"            : "x20",
    "C_AND_E"              : "x21",
    "CHLORE_5F"            : "x4",
    "CHLORILIQUE_C"        : "",
    "S_AND_E_20"           : "x12",
    "S_AND_E_30"           : "x22",
    "SOFTSWIM_MULTI"       : "x23",
    "BAYROSOFT"            : "x24",
    "BAYROSOFT_LIGHT"      : "x24l",
    "DESALGINE"            : "x15",
    "DESALGINE_JET"        : "x13",
    "CL_MICROBILLE"         : "x28",
    "CL_MICROBILLELONG"     : "x27",
    "DISINF_PLUS"           : "x29",
    "BROME_SPATIME"         : "x30",
    "OXY_SPATIME"         : "x31",
    "ACTIVE_OXY_SPATIME"    : "x32",
    "CHLORYTE_STICKS"    : "x37",
    "ANTICALCAIRE_AQUAPURE" : "a1",
    "ALCAFIX_AQUAPURE"      : "atac",
    "PH_PLUS_AQUAPURE"      : "aph+",
    "PH_MINUS_AQUAPURE"     : "aph-",
    "CHLORE_CHOC_PASTILLE_AQUAPURE"      : "a2",
    "CHLORE_RAPIDE_GRANULES_AQUAPURE" : "a3",
    "OXYDANT_CHOC_AQUAPURE" : "a14",
    "ARRET_METAL_AQUAPURE" : "a29",
    "OXYGEN_ACTIF_AQUAPURE": "a18",
    "CHLORE_LENT_GALETS_250_AQUAPURE" : "a6" ,
    "CHLORE_LENT_GALETS_500_AQUAPURE" :  "a7", 
    "CHLORE_MULTIACTIONS_GALETS_250_AQUAPURE": "a8" ,
    "CHLORE_MULTIACTIONS_GALETS_500_AQUAPURE":  "a9", 
    "CHLORE_LIQUIDE_AQUAPURE": "" ,
    "BROME_PASTILLES_AQUAPURE": "" ,
    "ANTI_ALGUE_AQUAPURE": "a19",
    "ANTI_ALGUE_MULTIACTIONS_AQUAPURE": "a20"
};

/**
 * products translation codes
 */
var productTr = {
    "NOPHOS"              : "fields.values.pool.p_advanced_other.NOPHOS",
    "SUPERFLOCK_PLUS"              : "fields.values.pool.p_flocculation.SUPERFLOCK_PLUS",
    "PH_PLUS"              : "fields.values.pool.p_ph_correction.PH_PLUS",
    "PH_MINUS"             : "fields.values.pool.p_ph_correction.PH_MINUS",
    "ALCA_PLUS"            : "fields.values.pool.p_alkalinity.ALCA_PLUS",
    "ALCAPLUS"            : "fields.values.pool.p_alkalinity.ALCA_PLUS",
    "CALCINEX"             : "fields.values.pool.p_hardness.CALCINEX",
    "CHLORIKLAR"           : "fields.values.pool.p_disinf_shock.CHLORIKLAR",
    "CHLORIFIX"            : "fields.values.pool.p_disinf_shock.CHLORIFIX_MICRO",
    "CHLORYTE"             : "fields.values.pool.p_disinf_shock.CHLORYTE",
    "BAYROSHOCK"           : "fields.values.pool.p_disinf_shock.BAYROSHOCK",
    "BAYROSHOCK_LIGHT"     : "fields.values.pool.p_disinf_shock.BAYROSHOCK_LIGHT",
    "AQUABROME"            : "fields.values.pool.p_disinf_long.AQUABROME",
    "AQUABROME_REGENERATOR": "fields.values.pool.p_disinf_shock.AQUABROME_REGENERATOR",
    "CHLORILONG"           : "fields.values.pool.p_disinf_long.CHLORILONG_250",
    "CHLORILONG_5F"        : "fields.values.pool.p_disinf_long.CHLORILONG_5FUNC",
    "CHLORYTE_STICKS"      : "fields.values.pool.p_disinf_long.CHLORYTE_STICKS",
    "VARITAB"              : "fields.values.pool.p_disinf_long.VARITAB",
    "CHLORILONG_BLOC"      : "fields.values.pool.p_disinf_long.CHLORILONG_BLOC",
    "MULTIBLOC"            : "fields.values.pool.p_disinf_long.MULTIBLOC",
    "MULTILONG"            : "fields.values.pool.p_disinf_long.MULTILONG",
    "C_AND_E"              : "fields.values.pool.p_disinf_long.COMPLETE_EASY",
    "CHLORE_5F"            : "fields.values.pool.p_disinf_long.CHLORE_5F",
    "CHLORILIQUE_C"        : "fields.values.pool.p_disinf_long.CHLORILIQ_C",
    "S_AND_E_20"           : "fields.values.pool.p_disinf_long.SOFT_EASY_20",
    "S_AND_E_30"           : "fields.values.pool.p_disinf_long.SOFT_EASY_30",
    "SOFTSWIM_MULTI"       : "fields.values.pool.p_disinf_long.SOFT_SWIM_MULTI",
    "BAYROSOFT"            : "fields.values.pool.p_disinf_long.BAYROSOFT",
    "BAYROSOFT_LIGHT"      : "fields.values.pool.p_disinf_long.BAYROSOFT_LIGHT",
    "DESALGINE"            : "fields.values.pool.p_algae.DESALGINE",
    "DESALGINE_JET"        : "fields.values.pool.p_algae.DESALGINE_JET",
    "FOUNTAIN"              : "fields.values.pool.p_extra_installation.FOUNTAIN",
    "CASCAD"                : "fields.values.pool.p_extra_installation.CASCAD",
    "SWIM_AGAINST"          : "fields.values.pool.p_extra_installation.SWIM_AGAINST",
    "INFINITY_POOL"        : "fields.values.pool.p_extra_installation.INFINITY_POOL",
    "OTHER"                 : "fields.values.pool.p_extra_installation.OTHER",
    "CL_MICROBILLE"         : "fields.values.spa.s_disinf_shock.CL_MICROBILLE",
    "CL_MICROBILLELONG"     : "fields.values.spa.s_disinf_long.CL_MICROBILLELONG",
    "DISINF_PLUS"           : "fields.values.spa.s_disinf_shock.DISINF_PLUS",
    "BROME_SPATIME"         : "fields.values.spa.s_disinf_long.BROME_SPATIME",
    "ACTIVE_OXY_SPATIME"    : "fields.values.spa.s_disinf_shock.ACTIVE_OXY_SPATIME",
    "OXY_SPATIME"           : "fields.values.spa.s_disinf_long.OXY_SPATIME",
    "ANTICALCAIRE_AQUAPURE" : "products.AQUAPURE.ANTICALCAIRE_AQUAPURE",
    "ALCAFIX_AQUAPURE"      : "products.AQUAPURE.ALCAFIX_AQUAPURE",
    "PH_PLUS_AQUAPURE"      : "products.AQUAPURE.PH_PLUS_AQUAPURE",
    "PH_MINUS_AQUAPURE"     : "products.AQUAPURE.PH_MINUS_AQUAPURE",
    "CHLORE_CHOC_PASTILLE_AQUAPURE"      : "products.AQUAPURE.CHLORE_CHOC_PASTILLE_AQUAPURE",
    "CHLORE_RAPIDE_GRANULES_AQUAPURE" : "products.AQUAPURE.CHLORE_RAPIDE_GRANULES_AQUAPURE",
    "OXYDANT_CHOC_AQUAPURE" : "products.AQUAPURE.OXYDANT_CHOC_AQUAPURE",
    "ARRET_METAL_AQUAPURE" : "products.AQUAPURE.ARRET_METAL_AQUAPURE",
    "OXYGEN_ACTIF_AQUAPURE" : "products.AQUAPURE.OXYGEN_ACTIF_AQUAPURE" ,
    "CHLORE_LENT_GALETS_250_AQUAPURE" : "products.AQUAPURE.CHLORE_LENT_GALETS_250_AQUAPURE" ,
    "CHLORE_LENT_GALETS_500_AQUAPURE" :  "products.AQUAPURE.CHLORE_LENT_GALETS_500_AQUAPURE", 
    "CHLORE_MULTIACTIONS_GALETS_250_AQUAPURE": "products.AQUAPURE.CHLORE_MULTIACTIONS_GALETS_250_AQUAPURE" ,
    "CHLORE_MULTIACTIONS_GALETS_500_AQUAPURE":  "products.AQUAPURE.CHLORE_MULTIACTIONS_GALETS_500_AQUAPURE", 
    "CHLORE_LIQUIDE_AQUAPURE": "products.AQUAPURE.CHLORE_LIQUIDE_AQUAPURE" ,
    "BROME_PASTILLES_AQUAPURE": "products.AQUAPURE.BROME_PASTILLES_AQUAPURE" ,
    "ANTI_ALGUE_AQUAPURE": "products.AQUAPURE.ANTI_ALGUE_AQUAPURE" ,
    "ANTI_ALGUE_MULTIACTIONS_AQUAPURE": "products.AQUAPURE.ANTI_ALGUE_MULTIACTIONS_AQUAPURE" ,
};

/**
 * Remove not allowed products following pool parameters
 *
 * @param array {Array} array of product code
 * @param input {object} diag input object
 */
function removeNotAllowedProducts(array, input){
    var result = [] ;
    array.forEach(function(product){
        if(product === "CHLORILONG") {
            if (input.pool.volume >= 15 && input.pool.volume <= 210) {
                result.push(product);
            }
        }else if(product === "CHLORILONG_BLOC") {
            if (input.pool.volume >= 20 && input.pool.volume <= 210) {
                result.push(product);
            }
        }else if(product === "CHLORYTE_STICKS") {
            if (input.pool.volume >= 15 && input.pool.volume <= 120) {
                result.push(product);
            }
        }else if(product === "CHLORILONG_5F"){
            if(input.pool.volume >= 15 && input.pool.volume <= 210 &&
                ["GLASS", "SAND", "CARTRIDGE", "POCKET"].indexOf(input.pool.filter) !== -1) {
                result.push(product) ;
            }
        }else if(product === "CHLORE_5F"){
            if(input.pool.volume >= 0.6 && input.pool.volume < 15 &&
            ["GLASS", "SAND", "CARTRIDGE", "POCKET"].indexOf(input.pool.filter) !== -1) {
                result.push(product);
            }
        }else if(product === "VARITAB"){
            if(input.pool.volume >= 20 && input.pool.volume <= 210 &&
            ["GLASS", "SAND"].indexOf(input.pool.filter) !== -1) {
                result.push(product);
            }
        }else if(product === "MULTIBLOC") {
            if(input.pool.volume >= 25 && input.pool.volume <= 210 &&
            ["GLASS", "SAND", "CARTRIDGE", "POCKET"].indexOf(input.pool.filter) !== -1) {
                result.push(product);
            }
        }else if(product === "MULTILONG") {
            if(input.pool.volume >= 30 && input.pool.volume <= 200 &&
            ["GLASS", "SAND"].indexOf(input.pool.filter) !== -1) {
                result.push(product);
            }
        }else if(product === "S_AND_E_20") {
            if(input.pool.volume >= 11 && input.pool.volume <= 100 &&
            ["GLASS", "SAND", "CARTRIDGE", "POCKET"].indexOf(input.pool.filter) !== -1) {
                result.push(product);
            }
        }else if(product === "S_AND_E_30") {
            if(input.pool.volume >= 21 && input.pool.volume <= 120 &&
            ["GLASS", "SAND", "CARTRIDGE", "POCKET"].indexOf(input.pool.filter) !== -1) {
                result.push(product);
            }
        }else if(product === "C_AND_E") {
            if(input.pool.volume >= 11 && input.pool.volume <= 100 &&
                ["GLASS", "SAND", "CARTRIDGE", "POCKET"].indexOf(input.pool.filter) !== -1) {
                result.push(product);
            }
        }else if(product === "DISINF_PLUS") {
            if(input.pool.volume >= 0.21 && input.pool.volume <= 4.9) {
                result.push(product);
            }
        }else if(product === "BROME_SPATIME") {
            if(input.pool.volume >= 0.21 && input.pool.volume <= 10.2) {
                result.push(product);
            }
        }else if(product === "CHLORIKLAR" || product === "CHLORIFIX" || product === "CHLORYTE") {
            if(input.pool.disinf !== "O2" || !input.pool.long || input.pool.long.length !== 1 || input.pool.long[0] !== "BAYROSOFT_LIGHT") {
                //if not oxygen or not only bayroft light (if only bayrosoft light don't add it)
                result.push(product);
            }
        }else{
            result.push(product) ;
        }
    }) ;
    return result.filter(function(p){
        //filter by country availability
        return disinfExt.COUNTRY_AVAILABILITY[p][VeloxWebView.country.get()] ;
    }) ;
} ;

/**
 * Remove product that we can't use with regulation
 * @param array
 */
function removeNotRegulProducts(array){
    var result = [] ;
    array.forEach(function(product){
        if(product === "CHLORILONG") {
            result.push(product);
        }else if(product === "CHLORILIQUE_C") {
            result.push(product);
        }
    }) ;
    return result;
} ;

function qtyStr(prod, values, isForRegul) {
    if(VeloxWebView.tr(productTr[prod]) === "n/a"){ return "" ; }//unavailable product
    var qty = productQties[prod];
    if(isForRegul && prod === "CHLORILONG"){
        qty = "" ; //no quantity for CHLORILONG in REGUL case
    }
    if (qty === undefined) {
        throw "Can't find qty for " + prod;
    }
    
    var str = VeloxWebView.tr(productTr[prod]) ;
    if(str[str.length-1] === ")"){
        str =  "*" +str.substring(0, str.lastIndexOf("("))+"* `" +str.substring(str.lastIndexOf("("))+"`" ;
    }else{
        str = "*" + str + "*";
    }
    
    if(["x18", "x19", "x20"].indexOf(qty) !== -1){
        str = "{{"+qty+"}} "+ str ;   
    }else if (qty) {
        str = VeloxWebView.tr("diag.qtyOf",{qty : "___QTY___", label : str}).replace("___QTY___", "{{"+qty+"}}") ;
    }

    return Mustache.render(str, values);
}

function addQty(usedProducts, values, knownProducts, isForRegul) {
    var prods = usedProducts;
    if (usedProducts.length === 0 && knownProducts) {
        prods = knownProducts;
    }
    var result = [];

    prods.forEach(function (p) {
        var str = qtyStr(p, values, isForRegul) ;
        if(str){
            result.push(str);
        }
    });

    return result;
}

function asLabel(prods) {
    var result = [];

    prods.forEach(function (prod) {
        result.push(VeloxWebView.tr(productTr[prod])) ;
    });

    return result;
}

/**
* Aggregate all values of diag to create the template values
*
* @param diag
* @returns {object} flat values
*/
function aggregateValues(diag, fieldsValues, customerData) {
    var values = {};
    Object.keys(diag.input.measures).forEach(function (k) {
        values[k] = diag.input.measures[k];
    });
    Object.keys(diag.input.options).forEach(function (k) {
        values[k] = diag.input.options[k];
    });
    Object.keys(diag.input.pool).forEach(function (k) {
        values[k] = diag.input.pool[k];
    });
    values.signs = {} ;

    values.signs.alk = fieldsValues.d_alk_sign || "";
    values.signs.ph = fieldsValues.d_ph_sign || "";
    values.signs.hardness = fieldsValues.d_hardness_sign || "";
    values.signs.freeCl = fieldsValues.d_free_cl_sign || "";
    values.signs.totalCl = fieldsValues.d_total_cl_sign || "";
    values.signs.bromine = fieldsValues.d_br_sign || "";
    values.signs.salt = fieldsValues.d_salt_sign || "";
    values.signs.oxygen = fieldsValues.d_oxygen_sign || "";
    values.signs.cu = fieldsValues.d_cu_sign || "";
    values.signs.fe = fieldsValues.d_fe_sign || "";
    values.signs.stab = fieldsValues.d_stab_sign || "";
    values.signs.phosphate = fieldsValues.d_phosphate_sign || "";
     
   Object.keys(diag.variables.references).forEach(function (k) {
       values[k] = diag.variables.references[k];
   });
   Object.keys(diag.variables.computed).forEach(function (k) {
       values[k] = diag.variables.computed[k];
   });
   Object.keys(diag.variables.dosage).forEach(function (k) {
       values[k] = diag.variables.dosage[k];
   });

   values.diagPrice = fieldsValues.d_diag_price ;
   values.diagUser = fieldsValues.d_diag_user ;
   values.date = moment(fieldsValues.d_date).format("L");


    
    Object.keys(PRODUCTS).forEach(function(catalog){
        values["CL_SHOCK_PRODUCTS_"+catalog] = addQty(
            PRODUCTS[catalog].removeNotAllowedProducts(PRODUCTS[catalog].pool.CL.SHOCK, diag.input, fieldsValues.hiddenProducts[catalog]), values) ;
        values["CL_LONG_PRODUCTS_"+catalog] = addQty(
            PRODUCTS[catalog].removeNotAllowedProducts(PRODUCTS[catalog].pool.CL.LONG, diag.input, fieldsValues.hiddenProducts[catalog]), values) ;
        values["BR_SHOCK_PRODUCTS_"+catalog] = addQty(
            PRODUCTS[catalog].removeNotAllowedProducts(PRODUCTS[catalog].pool.BR.SHOCK, diag.input, fieldsValues.hiddenProducts[catalog]), values) ;
        values["BR_LONG_PRODUCTS_"+catalog] = addQty(
            PRODUCTS[catalog].removeNotAllowedProducts(PRODUCTS[catalog].pool.BR.LONG, diag.input, fieldsValues.hiddenProducts[catalog]), values) ;
        values["O2_SHOCK_PRODUCTS_"+catalog] = addQty(
            PRODUCTS[catalog].removeNotAllowedProducts(PRODUCTS[catalog].pool.O2.SHOCK, diag.input, fieldsValues.hiddenProducts[catalog]), values) ;
        values["O2_LONG_PRODUCTS_"+catalog] = addQty(
            PRODUCTS[catalog].removeNotAllowedProducts(PRODUCTS[catalog].pool.O2.LONG, diag.input, fieldsValues.hiddenProducts[catalog]), values) ;
        values["ALG_PRODUCTS_"+catalog] = addQty(
            PRODUCTS[catalog].removeNotAllowedProducts(PRODUCTS[catalog].pool.ALG, diag.input, fieldsValues.hiddenProducts[catalog]), values) ;
    }) ;

    values.OR_SEP = function () {
        return function (text) {
            if (this[text] === undefined) {
                return text;
            }
            return this[text].join(VeloxWebView.tr("diag.or"));
        };
    };

    values.LIST_SEP = function () {
        return function (text) {
            if (this[text] === undefined) {
                return text;
            }
            var prefix = "" ;
            var postfix = "" ;
            var subClass = ""  ;
            if(this[text].length>1){
                prefix = VeloxWebView.tr("diag.oneProductIn")+'  {.BLOCK_MANY} \n\n' ;
                subClass = ".sub"  ;
                postfix = '<div class="productMany"></div>' ;
            }else{
                subClass = ".productEntry"  ;
            }
            var textArray = this[text] ;
            var returnText =  prefix+textArray.map(function(oneText, i){
                    var imgClass = oneText.substring(oneText.indexOf("*")+1, oneText.lastIndexOf("*")) ;
                    imgClass = "IMG_"+imgClass.toUpperCase().replace(/[^A-Z0-9]/g, "") ;
                    imgClass = "{."+imgClass+subClass+"}\n"  ;
                    return imgClass+oneText+(i===textArray.length-1?postfix:"") ;
                }).join(" \n\n");



            return returnText ;
        };
    };

    values.COMMA_SEP = function () {
        return function (text) {
            if (this[text] === undefined || !Array.isArray(this[text])) {
                return text;
            }
            return this[text].join(", ");
        };
    };




    values.poolOrSpaLabel = values.poolOrSpa==="pool"?VeloxWebView.tr("customers.pool"):VeloxWebView.tr("customers.spa");
    values.filterLabel = values.filter?VeloxWebView.tr("fields.values.diag.p_filter."+values.filter):" - " ;
    values.regulLabel = " - ";
    if(values.regul && values.regul === "OTHER"){
        values.regulLabel = fieldsValues.regul_other ;
    }else if(values.regul){
        values.regulLabel = VeloxWebView.tr("fields.values.diag.p_regulation."+values.regul) ;
    }

    values.coverLabel = " - ";
    if(values.poolCover && values.poolCover === "OTHER"){
        values.coverLabel = fieldsValues.poolCover_other ;
    }else if(values.poolCover){
        values.coverLabel = VeloxWebView.tr("fields.values.diag.p_pool_cover."+values.poolCover) ;
    }

    values.elecLabel = " - ";
    if(fieldsValues.electrolyzer && fieldsValues.electrolyzer.electrolyzer === "OTHER"){
        values.elecLabel = fieldsValues.electrolyzer_other ;
    }else if(fieldsValues.electrolyzer && fieldsValues.electrolyzer.electrolyzer){
        values.elecLabel = VeloxWebView.tr("fields.values.diag.p_electrolyzer."+fieldsValues.electrolyzer.electrolyzer) ;
    }

    values.disinfLabel = values.disinf?VeloxWebView.tr("fields.values.diag.p_disinfectant."+values.disinfFull):" - " ;
    if(values.saltElect){
        //special case of electrolizer that is seen as CL
        values.disinfLabel =  VeloxWebView.tr("fields.values.diag.p_disinfectant.SALT") ;
    }

    values.customer_name = fieldsValues.d_customer_name;

    return values;
};

/**
 * create the condition CSS class for HTML template
 */
function createConditionalClasses(diag, values, plainAddedBlocks, replaces, currentData) {

    //compute the conditional classes
    var visible = "{}";
    var hidden = "{display: none !important}";
    var classes = [];

        
    classes.push(".VOL_LESS_5 " + (
        (diag.input.pool.volume < 5 ) ? visible : hidden));
        
    classes.push(".FILTER_GLASS_OR_SAND " + (
        (diag.input.pool.filter === "SAND" || diag.input.pool.filter === "GLASS") ? visible : hidden));

    classes.push(".IS_SPA " + (
        (diag.input.pool.isSpa) ? visible : hidden));
    
    classes.push(".IS_POOL " + (
        (diag.input.pool.isPool) ? visible : hidden));


    classes.push(".FILTER_CART " + (
        (diag.input.pool.filter === "CARTRIDGE" || diag.input.pool.filter === "DIATOM" || diag.input.pool.filter === "POCKET" ) ? visible : hidden));

    classes.push(".NOT_FILTER_GLASS_OR_SAND " + (
        (diag.input.pool.filter !== "SAND" && diag.input.pool.filter !== "GLASS") ? visible : hidden));

    classes.push(".USE_AQUABROME_REG " + (
        (diag.input.pool.shock.indexOf("AQUABROME_REGENERATOR") !== -1 || diag.input.pool.shock.length === 0) ? visible : hidden));

    classes.push(".USE_CHLORYTE " + (
        (diag.input.pool.shock.indexOf("CHLORYTE") !== -1 || diag.input.pool.shock.length === 0) ? visible : hidden));

    classes.push(".USE_CHLORIKLAR " + (
        (diag.input.pool.shock.indexOf("CHLORIKLAR") !== -1 || diag.input.pool.shock.length === 0) ? visible : hidden));

    classes.push(".USE_CHLORIFIX " + (
        (diag.input.pool.shock.indexOf("CHLORIFIX") !== -1 || diag.input.pool.shock.length === 0) ? visible : hidden));
    
    classes.push(".USE_MICROBILLE " + (
        (diag.input.pool.shock.indexOf("CL_MICROBILLE") !== -1 || diag.input.pool.shock.length === 0) ? visible : hidden));
    
    classes.push(".USE_DESINF " + (
        (diag.input.pool.shock.indexOf("DISINF_PLUS") !== -1 || diag.input.pool.shock.length === 0) ? visible : hidden));

    classes.push(".NOT_MULTILONG_AND_NOT_VARITAB " + (
        diag.input.pool.long.indexOf("MULTILONG") === -1 && diag.input.pool.long.indexOf("VARITAB") === -1 ? visible : hidden));


    classes.push(".HAS_MEASURE_ALK " + (
        (!currentData.domain.do_hide_alk) ? visible : hidden));
    classes.push(".HAS_MEASURE_HARDNESS " + (
        (!currentData.domain.do_hide_hardness) ? visible : hidden));
    classes.push(".HAS_MEASURE_TOTAL_CL " + (
        (!currentData.domain.do_hide_total_cl) ? visible : hidden));
    classes.push(".HAS_MEASURE_SALT " + (
        (!currentData.domain.do_hide_salt) ? visible : hidden));
    classes.push(".HAS_MEASURE_OXYGEN " + (
        (!currentData.domain.do_hide_oxygen && diag.input.measures.oxygen) ? visible : hidden));
    classes.push(".HAS_MEASURE_CU " + (
        (!currentData.domain.do_hide_cu) ? visible : hidden));
    classes.push(".HAS_MEASURE_FE " + (
        (!currentData.domain.do_hide_fe) ? visible : hidden));
    classes.push(".HAS_MEASURE_STAB " + (
        (!currentData.domain.do_hide_fe) ? visible : hidden));
    classes.push(".HAS_MEASURE_PHOSPHATE " + (
        (!currentData.domain.do_hide_fe) ? visible : hidden));



    classes.push(".USE_COVER " + (
        (diag.input.pool.poolCover) ? visible : hidden));

    classes.push(".USE_REGUL " + (
        (diag.input.pool.regul) ? visible : hidden));
    
    classes.push(".USE_REGUL_AND_CHLORE " + (
        (diag.input.pool.regul && diag.input.pool.disinf === "CL" && !diag.input.pool.saltElect) ? visible : hidden));

    classes.push(".USE_ELEC " + (
        (diag.input.pool.saltElect) ? visible : hidden));
    
    classes.push(".USE_ELEC_NO_REGUL " + (
        (diag.input.pool.saltElect && !diag.input.pool.regul) ? visible : hidden));
    
    classes.push(".USE_ELEC_AND_REGUL " + (
        (diag.input.pool.saltElect && diag.input.pool.regul) ? visible : hidden));

    classes.push(".HAS_ELEC " + (
        (diag.input.pool.electrolyzer) ? visible : hidden));

    classes.push(".NO_ELEC " + (
        (!diag.input.pool.electrolyzer) ? visible : hidden));

    classes.push(".NO_REGUL " + (
        (!diag.input.pool.regul) ? visible : hidden));

    classes.push(".NO_REGUL_AND_NO_ELEC " + (
        (!diag.input.pool.regul && !diag.input.pool.saltElect) ? visible : hidden));

    classes.push(".NOT_POOLRELAX_AND_NOT_POOLMANAGER " + (
        (diag.input.pool.regul !== "POOL_RELAX" &&
            diag.input.pool.regul !== "POOL_MANAGER") ? visible : hidden));

    classes.push(".NOT_POOLRELAX_AND_NOT_POOLMANAGER_AND_NO_ELEC " + (
        (diag.input.pool.regul !== "POOL_RELAX" && 
            diag.input.pool.regul !== "POOL_MANAGER" && 
            diag.input.pool.regul !== "AUTOMATIC_CLPH" && 
            !diag.input.pool.saltElect) ? visible : hidden));

    classes.push(".USE_POOLRELAX_OR_POOLMANAGER " + (
        (
            diag.input.pool.regul === "POOL_RELAX" || 
            diag.input.pool.regul === "POOL_MANAGER"
        ) ? visible : hidden));
    
    classes.push(".USE_POOL_REGUL " + (
        (
            diag.input.pool.regul === "POOL_RELAX" || 
            diag.input.pool.regul === "POOL_MANAGER" 
        ) ? visible : hidden));

    classes.push(".USE_AUTOMATIC_PH " + (
        (
            diag.input.pool.regul === "AUTOMATIC_CLPH" || 
            diag.input.pool.regul === "AUTOMATIC_PH" 
        ) ? visible : hidden));
    classes.push(".USE_AUTOMATIC_CLPH " + (
        (
            diag.input.pool.regul === "AUTOMATIC_CLPH"
        ) ? visible : hidden));


    classes.push(".CL_TOTAL_HIGH " + (
        (diag.variables.computed.clTotalHigh) ? visible : hidden));

    classes.push(".CHLORINE " + (
        (diag.input.pool.disinf === "CL" ? visible : hidden) ));
    
    classes.push(".NOT_CHLORINE " + (
        (diag.input.pool.disinf !== "CL" ? visible : hidden) ));

    classes.push(".CHLORINE_OR_O2 " + (
        ((diag.input.pool.disinf === "CL" ||
            diag.input.pool.disinf === "O2") ? visible : hidden) ));

    classes.push(".CHLORINE_OR_O2_AND_STAB_HI " + (
        ((diag.input.pool.disinf === "CL" ||
            (diag.input.pool.disinf === "O2" && diag.variables.computed.stabHigh)) ? visible : hidden) ));

    classes.push(".BROMINE " + (
        (diag.input.pool.disinf === "BR" ? visible : hidden) ));

    classes.push(".O2 " + (
        (diag.input.pool.disinf === "O2"  ? visible : hidden) ));

    classes.push(".ALK_OK " + (
        (diag.variables.computed.alkOk && diag.input.measures.displayedAlk !== "") ? visible : hidden));

    classes.push(".PH_OK " + (
        (diag.variables.computed.phOk) ? visible : hidden));

    classes.push(".CL_OK " + (
        (diag.variables.computed.clOk) ? visible : hidden));

    classes.push(".CL_TOTAL_OK " + (
        (!diag.variables.computed.clTotalHigh  && diag.input.measures.displayedClTotal !== "") ? visible : hidden));

    classes.push(".BR_OK " + (
        (diag.variables.computed.brOk) ? visible : hidden));

    classes.push(".TH_OK " + (
        (diag.variables.computed.thOk && diag.input.measures.displayedTh !== "") ? visible : hidden));

    classes.push(".SALT_OK " + (
        (!diag.variables.computed.saltLow && diag.input.measures.displayedSalt !== "") ? visible : hidden));

    classes.push(".FE_OK " + (
        (diag.variables.computed.feZero  && diag.input.measures.displayedFe !== "") ? visible : hidden));

    classes.push(".CU_OK " + (
        (diag.variables.computed.cuZero && diag.input.measures.displayedCu !== "") ? visible : hidden));

    classes.push(".STAB_OK " + (
        (!diag.variables.computed.stabHigh && diag.input.measures.displayedStab !== "") ? visible : hidden));


    classes.push(".ALK_NOT_OK " + (
        (!diag.variables.computed.alkOk && diag.input.measures.displayedAlk !== "") ? visible : hidden));

    classes.push(".PH_NOT_OK " + (
        (!diag.variables.computed.phOk) ? visible : hidden));

    classes.push(".CL_NOT_OK " + (
        (!diag.variables.computed.clOk) ? visible : hidden));

    classes.push(".CL_TOTAL_NOT_OK " + (
        (diag.variables.computed.clTotalHigh) ? visible : hidden));

    classes.push(".BR_NOT_OK " + (
        (!diag.variables.computed.brOk) ? visible : hidden));

    classes.push(".TH_NOT_OK " + (
        (!diag.variables.computed.thOk && diag.input.measures.displayedTh !== "") ? visible : hidden));

    classes.push(".ALK_UNDEF " + (
        (diag.input.measures.displayedAlk === "") ? visible : hidden));

    classes.push(".TH_UNDEF " + (
        (diag.input.measures.displayedTh === "") ? visible : hidden));

    classes.push(".STAB_UNDEF " + (
        (diag.input.measures.displayedStab === "") ? visible : hidden));

    classes.push(".FE_UNDEF " + (
        (diag.input.measures.displayedFe === "") ? visible : hidden));

    classes.push(".CU_UNDEF " + (
        (diag.input.measures.displayedCu === "") ? visible : hidden));

    classes.push(".CL_TOTAL_UNDEF " + (
        (diag.input.measures.displayedClTotal === "") ? visible : hidden));

    classes.push(".SALT_UNDEF " + (
        (diag.input.measures.displayedSalt === "" ) ? visible : hidden));

    classes.push(".SALT_NOT_OK " + (
        (diag.variables.computed.saltLow) ? visible : hidden));

    classes.push(".FE_NOT_OK " + (
        (!diag.variables.computed.feZero) ? visible : hidden));

    classes.push(".CU_NOT_OK " + (
        (!diag.variables.computed.cuZero) ? visible : hidden));

    classes.push(".STAB_NOT_OK " + (
        (diag.variables.computed.stabHigh) ? visible : hidden));

    classes.push(".MOD_ALG " + (
        (diag.input.options.mode === "ALG") ? visible : hidden));

    classes.push(".MOD_TROU " + (
        (diag.input.options.mode === "TROUBLED") ? visible : hidden));

    classes.push(".MOD_COL " + (
        (diag.input.options.mode === "COLOR") ? visible : hidden));

    classes.push(".MOD_VER " + (
        (diag.input.options.mode === "VER") ? visible : hidden));

    classes.push(".NOT_MOD_VER " + (
        (diag.input.options.mode !== "VER") ? visible : hidden));

    classes.push(".OPT_FILTER " + (
        (diag.input.options.filterMaint) ? visible : hidden));

    classes.push(".OPT_LINE " + (
        (diag.input.options.cleanLine) ? visible : hidden));

    classes.push(".OPT_START " + (
        (diag.input.options.startUp) ? visible : hidden));

    classes.push(".OPT_WINTER " + (
        (diag.input.options.wintering) ? visible : hidden));

    classes.push(".OPT_MARK " + (
        (diag.input.options.mark) ? visible : hidden));
    
    classes.push(".HAS_TEXT_ALG " + (
        (diag.input.options.textAlg) ? visible : hidden));
    classes.push(".HAS_TEXT_TROUBLED " + (
        (diag.input.options.textTroubled) ? visible : hidden));
    
    classes.push(".OPT_MARK_SPA " + (
        (diag.input.options.markSpa) ? visible : hidden));
    classes.push(".OPT_MOUSSE " + (
        (diag.input.options.mousse) ? visible : hidden));
    classes.push(".OPT_TROUBLE " + (
        (diag.input.options.troubleWater) ? visible : hidden));
    classes.push(".OPT_GREEN_ALGAE " + (
        (diag.input.options.greenWaterAlgae) ? visible : hidden));
    classes.push(".OPT_GREEN_CRYSTAL " + (
        (diag.input.options.greenWaterCrystal) ? visible : hidden));
    
    var hasPbSpa = diag.input.pool.isSpa && (diag.input.options.markSpa || diag.input.options.mousse
                    || diag.input.options.troubleWater || diag.input.options.greenWaterAlgae
                    || diag.input.options.greenWaterCrystal) ;
    
    classes.push(".NO_PB_SPA " + (
        (!hasPbSpa) ? visible : hidden));
    classes.push(".WITH_PB_SPA " + (
        (hasPbSpa) ? visible : hidden));
    
    
    var hasPbPoolTop= !diag.input.pool.isSpa && (
            diag.input.options.modeTroubled || diag.input.options.modeAlg || 
            diag.input.options.modeColor) ;
    
    classes.push(".NO_PB_TOP " + (
        (!hasPbSpa && !hasPbPoolTop) ? visible : hidden));
    classes.push(".WITH_PB_TOP " + (
        (hasPbSpa || hasPbPoolTop) ? visible : hidden));
        
    classes.push(".HAS_BLOCK " + (
        (replaces["@BLOCKS_1@" || "@BLOCKS_2@" || "@BLOCKS_3@"
            || "@BLOCKS_4@"|| "@BLOCKS_5@"|| "@BLOCKS_6@"]) ? visible : hidden));
    

    classes.push(".HAS_SALT_DISOLVED " + (
        (diag.input.measures.displayedSaltDisolved !== "") ? visible : hidden));

    classes.push(".HAS_PHOSPHATE " + (
        (diag.input.measures.displayedPhos !== "") ? visible : hidden));

    classes.push(".PHOSPHATE_OK " + (
            (diag.variables.computed.phosOk) ? visible : hidden));

    classes.push(".PHOSPHATE_NOT_OK " + (
            (!diag.variables.computed.phosOk) ? visible : hidden));



    classes.push(".HAS_RECO " + (
        (diag.input.options.startUp || diag.input.options.wintering ||
        diag.input.options.filterMaint || diag.input.options.cleanLine || diag.input.options.mark) ? visible : hidden));

    classes.push(".HAS_USER " + (
            (values.diagUser) ? visible : hidden));

    classes.push(".FILTER_GLASS_OR_SAND_AND_NOT_MOD_ALG_AND_NOT_MOD_TROU " + (
        (["GLASS", "SAND"].indexOf(diag.input.pool.filter) !== -1 &&
            diag.input.options.mode !== "ALG" && diag.input.options.mode !== "TROUBLED") ? visible : hidden));

    classes.push(".NOT_FILTER_GLASS_OR_SAND_OR_MOD_ALG_OR_MOD_TROU " + (
        (["GLASS", "SAND"].indexOf(diag.input.pool.filter) === -1 ||
            diag.input.options.mode === "ALG" || diag.input.options.mode === "TROUBLED") ? visible : hidden));

    var shockIsOnlyChloryte = (diag.input.pool.shock.length === 1 && diag.input.pool.shock[0] === "CHLORYTE");
    var shockIsOnlyBayroshock = (diag.input.pool.shock.length === 1 && diag.input.pool.shock[0] === "BAYROSHOCK");
    var shockIsOnlyBayrolLight = (values.long.length === 1 && values.long[0] === "BAYROSOFT_LIGHT");
    var longIsSE20Only = (diag.input.pool.long.length === 1 && diag.input.pool.long[0] === "S_AND_E_20");
    var longIsSE30Only = (diag.input.pool.long.length === 1 && diag.input.pool.long[0] === "S_AND_E_30");
    var longIsSE20AndSE30Only = (diag.input.pool.long.length === 2 && diag.input.pool.long.indexOf("S_AND_E_30")!==-1
                            &&  diag.input.pool.long.indexOf("S_AND_E_20")!==-1);

    var isOnlyBayroshockOrIsOnlySE20SE30 = shockIsOnlyBayrolLight ||  shockIsOnlyBayroshock || longIsSE20Only || longIsSE30Only || longIsSE20AndSE30Only ;

    classes.push(".NOTONLY_CHLORYTE " + (
            (!shockIsOnlyChloryte) ? visible : hidden));

    classes.push(".NOT_BAYROSHOCK_AND_NOT_SE20_AND_NOT_SE30 " + (
        !isOnlyBayroshockOrIsOnlySE20SE30 ? visible : hidden));

    classes.push(".USE_BAYROSHOCK " + (
        (diag.input.pool.shock.indexOf("BAYROSHOCK") !== -1 || diag.input.pool.shock.length === 0) ? visible : hidden));

    classes.push(".PH_VERY_LOW " + (
        (diag.variables.computed.phVeryLow) ? visible : hidden));

    classes.push(".PH_VERY_HIGH " + (
        (diag.variables.computed.phVeryHigh) ? visible : hidden));

    classes.push(".ALK_VERY_LOW " + (
        (diag.variables.computed.alkVeryLow) ? visible : hidden));

    classes.push(".MOD_TROU_AND_CU_OR_FE " + (
        (diag.input.options.mode === "TROUBLED" &&
            (!diag.variables.computed.feZero || !diag.variables.computed.cuZero)) ? visible : hidden));

    classes.push(".MOD_ALG_AND_CU_OR_FE " + (
        (diag.input.options.mode === "ALG" && (!diag.variables.computed.feZero || !diag.variables.computed.cuZero)) ? visible : hidden));

    classes.push(".MOD_COL_AND_OTHER_BLOCK " + (
        (diag.input.options.mode === "COLOR" &&
            (diag.blockList.indexOf("STA_1") !== -1 ||
                diag.blockList.indexOf("PH_2") !== -1 ||
                diag.blockList.indexOf("CL_4") !== -1 ||
                diag.blockList.indexOf("SEL_1") !== -1 ||
                diag.blockList.indexOf("TH_1") !== -1 ||
                diag.blockList.indexOf("TH_2") !== -1 ||
                diag.blockList.indexOf("TH_3") !== -1
                )) ? visible : hidden));



    //Display stab if not null for CL. For O2, display only if high
    classes.push(".STAB_NOT_NULL " + (
        (
            (diag.input.measures.stab
            && diag.input.pool.disinf === "CL")
            ||
            (diag.variables.computed.stabHigh
            && diag.input.pool.disinf === "O2")
            ) ? visible : hidden));

    classes.push(".HAS_NOTE " + (
        (diag.input.globalNotes !== null && diag.input.globalNotes !=="" ) ? visible : hidden));

    classes.push(".USE_EQUIP " + (
        (diag.input.pool.equip && diag.input.pool.equip.length > 0 ) ? visible : hidden));
    
    classes.push(".NO_X30_QTY " + (
        (diag.variables.computed.noX30Qty) ? visible : hidden));
    
    classes.push(".HAS_X30_QTY " + (
        (!diag.variables.computed.noX30Qty) ? visible : hidden));


    var classesShopping = {
        HAS_CL_SHOCK : false,
        HAS_CL_LONG : false,
        HAS_BR_SHOCK : false,
        HAS_BR_LONG : false,
        HAS_ALG : false,
        HAS_O2_SHOCK : false,
        HAS_O2_LONG : false,
        HAS_ALCAPLUS : false,
        HAS_CALCINEX : false,
        HAS_FILTERCLEAN : false,
        HAS_PHMINUS : false,
        HAS_PHPLUS : false,
        HAS_DECALCIT : false,
        HAS_SUPERFLOCK : false,
        HAS_SUPERKLAR : false,
        HAS_NOPHOS : false,
        HAS_AQUABROME : false,
        HAS_DISINF_PLUS_SPATIME : false,
        HAS_BROME_SPATIME : false
    } ;

    plainAddedBlocks.forEach(function(blockSource){
        if(blockSource.indexOf("CL_SHOCK_PRODUCTS") !== -1){ classesShopping.HAS_CL_SHOCK = true ; }
        if(blockSource.indexOf("CL_LONG_PRODUCTS") !== -1){ classesShopping.HAS_CL_LONG = true ; }
        if(blockSource.indexOf("{{CL_LG_DUREE_") !== -1){ classesShopping.HAS_CL_LONG = true ; }
        if(blockSource.indexOf("ALG_PRODUCTS") !== -1){ classesShopping.HAS_ALG = true ; }
        if(blockSource.indexOf("BR_SHOCK_PRODUCTS") !== -1){ classesShopping.HAS_BR_SHOCK = true ; }
        if(blockSource.indexOf("O2_SHOCK_PRODUCTS") !== -1){ classesShopping.HAS_O2_SHOCK = true ; }
        if(blockSource.indexOf("O2_LONG_PRODUCTS") !== -1){ classesShopping.HAS_O2_LONG = true ; }
        if(blockSource.indexOf("{{xtac}}") !== -1){ classesShopping.HAS_ALCAPLUS = true ; }
        if(blockSource.indexOf("{{x1}}") !== -1){ classesShopping.HAS_CALCINEX = true ; }
        if(blockSource.indexOf("{{x9}}") !== -1){ classesShopping.HAS_DECALCIT = true ; }
        if(blockSource.indexOf("{{x17}}") !== -1){ classesShopping.HAS_FILTERCLEAN = true ; }
        if(blockSource.indexOf("{{xph-}}") !== -1){ classesShopping.HAS_PHMINUS = true ; }
        if(blockSource.indexOf("{{xph+}}") !== -1){ classesShopping.HAS_PHPLUS = true ; }
        if(blockSource.indexOf("{{x5}}") !== -1){ classesShopping.HAS_SUPERFLOCK = true ;}
        if(blockSource.indexOf("{{x16}}") !== -1){ classesShopping.HAS_SUPERKLAR = true ;}
        if(blockSource.indexOf("{{x25}}") !== -1){ classesShopping.HAS_NOPHOS = true ;}
        if(blockSource.indexOf("{{x29}}") !== -1){ classesShopping.HAS_DISINF_PLUS_SPATIME = true ;}
        if(blockSource.indexOf("{{x30}}") !== -1){ classesShopping.HAS_BROME_SPATIME = true ;}
        if(blockSource.indexOf("*Aquabrome*") !== -1){ classesShopping.HAS_AQUABROME = true ;}
    }) ;

    Object.keys(classesShopping).forEach(function(k){
        classes.push("."+k+" " + (
                (classesShopping[k]) ? visible : hidden));
    }) ;

    diag.results.forEach(function (res) {
        var block = res.block;
        classes.push("."+block+", ."+block+" p {display : block !important} ");
    });

    return classes.join("\n\n");
};

/**
 * User clicked on the diag start button
 * @param {*} ev 
 */
diagController.formController.onDiagStart = function(){
    VeloxWebView.longTask(function(done){
        this.view.checkForm(function(err, checkOk){
            if(err){ 
                // back to top if error
                if(document.querySelector('.main-views-wrapper')){
                    document.querySelector('.main-views-wrapper').scrollTop = 0;
                }
                return done(err);   
            }
            if(!checkOk){
                if(document.querySelector('.main-views-wrapper')){
                    document.querySelector('.main-views-wrapper').scrollTop = 0;
                }
                return done(null, false) ;
            }
            this.view.updateData() ;


            var diag = this.data;
            if(!diag.d_id){
                diag.d_id = uuid.v4() ;
            }
            diag.r_code = this.api.currentReseller
            diag.do_code = this.api.currentDomain
        
            var records = [
                {table: "diag", record: diag} 
            ] ;

            this.api.api.transactionalChanges(records, function(err){
                if(err){return done(err) ;}
                
                this.updateRouteData(diagController.formController.viewOptions.route, diag.d_id) ;

                diagController.formController.openReport(this.data, this.data.customer ?'WITH_CUSTOMER':'NO_CUSTOMER', done) ;
            }.bind(this)) ;

        }.bind(this)) ;
    }.bind(this)) ;
} ;


diagController.formController.getLogo = function(reseller_settings, callback){
    if(reseller_settings && reseller_settings.binary){
        this.api.readBinary.urlBase64(reseller_settings.binary, function(err, url){
            if(err){ return callback(err) ;}
            callback(null, url) ;
        }) ;
    }else{
        callback(null, "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8zwQAAgYBAyKDV6YAAAAASUVORK5CYII=") ;
    }
} ;

diagController.formController.createReportHTML = function(diagData, mode, done){
    if(!done) { done = function(){} ;}
    this.api.api.multiread({ 
        reseller_settings : {
            searchFirst: {},
            joinFetch: [{otherTable: "velox_binary", type: "2one", thisField: "r_code", otherField:"table_uid", name: "binary"}]
        }
    }, function(err, reads){
        if(err){ return done(err) ;}
        
        this.getLogo(reads.reseller_settings, function(err, logoUrl){
            if(err){ return done(err) ;}
            var settingsOptions = reads.reseller_settings||{} ;

            this.currentDiag = diagData;

            var inputData = getInputData(this.currentDiag) ;

            var t = VeloxWebView.tr ;
            var diag = new Diag(inputData, t);
            diag.doFullDiag();

            

            var values = aggregateValues(diag, this.currentDiag, diagData.customer);
        
            values.tr = trTemplate[VeloxWebView.i18n.getLang()].reportTemplate ;


            veloxScriptLoader.load([
                {name: "template-"+VeloxWebView.i18n.getLang(),
                    type: "plain",
                    version: "1.0.0",
                    localPath: "templates/html/template_"+VeloxWebView.i18n.getLang()+".html",
                }
            ], function(err, results){
                if(err){ return done(err) ;}
                var templateHTML = results[0][0] ;

                var reportHTML = templateHTML;

                //will contain the HTML to replace in report HTML
                var replaces = {
                    "@SHOP_LOGO@"   : logoUrl,
                    "@SHOP_NAME@"   : settingsOptions.rs_shop_name||"",
                    "@SHOP_TEXT@"   : settingsOptions.rs_textbox||"",
                    "@BLOCKS_0@"    : "",
                    "@BLOCKS_1@"    : "",
                    "@BLOCKS_2@"    : "",
                    "@BLOCKS_3@"    : "",
                    "@BLOCKS_4@"    : "",
                    "@BLOCKS_5@"    : "",
                    "@BLOCKS_6@"    : "",
                    "@BLOCKS_7@"    : "",
                    "@BLOCKS_8@"    : "",
                    "@BLOCKS_9a@"   : "",
                    "@BLOCKS_9b@"   : "",
                    "@BLOCKS_9c@"   : "",
                    "@BLOCKS_10@"   : "",
                    "@BLOCKS_20@"   : "",
                    "@BLOCKS_30@"   : "",
                    "@BLOCKS_40@"   : "",
                    "@GLOBAL_NOTES@": diag.input.globalNotes?diag.input.globalNotes.replace(/\n/g, "<br/>"):""
                };


                var plainBlocksAdded = [] ;

                diag.results.forEach(function (res) {
                    var order = res.order;
                    var pos = order.substring(0, order.indexOf("."));

                    var block = JSON.parse(JSON.stringify(BLOCKS[res.block])) ;

                    if (!block) {
                        console.log("BLOCK " + block + " not found in templates");
                        return;
                    }
                    
                    var titleRendered = Mustache.render(block.title, values);
                    var titleHTML = rho.toHtml(titleRendered);

                    var textRendered = "" ;
                    if(block.text){
                        textRendered = Mustache.render(block.text, values);
                    }
                    var textHTML = rho.toHtml(textRendered);

                    var manyCatalogs = false;
                    var catalogs = [] ;
                    if(block.catalogs){
                        catalogs = Object.keys(block.catalogs) ;
                        catalogs = catalogs.filter(function(c){
                            if(c === "BAYROL"){ return true ;}
                            return this.currentDiag.possibleCatalogs && this.currentDiag.possibleCatalogs.indexOf(c) !== -1 ;
                        }.bind(this)) ;
                        for(var i=0; i< catalogs.length; i++){
                            var catalog = catalogs[i] ;
                            if(block.catalogs[catalog].text){
                                for(var y=0; y < catalogs.length; y++){
                                    if(y !== i && block.catalogs[catalog].text !== block.catalogs[catalogs[y]].text){
                                        manyCatalogs = true ;
                                        break;
                                    }
                                }
                            }
                            if(block.catalogs[catalog].products){
                                for(var y=0; y < catalogs.length; y++){
                                    if(y !== i ){
                                        var thisProducts = block.catalogs[catalog].products;
                                        var otherProducts = block.catalogs[catalogs[y]].products;
                                        if(thisProducts.some(function(p, i){
                                            return otherProducts[i] !== p;
                                        })){
                                            manyCatalogs = true ;
                                            break;
                                        }
                                    }
                                }
                            }
                            if(manyCatalogs){ break ;}
                        }
                    }

                    var chosenCatalog = this.currentDiag.d_catalog||'BAYROL' ;

                    let blockHTML = `<tr>
                    <th class="product_title">
                        ${titleHTML}
                        ${(manyCatalogs && block.title!=" - ")?`
                        <select class="no-print" onChange="window.selectCatalog(this)">
                            ${catalogs.map((catalog)=>{
                                return `<option value="${catalog}" ${catalog===chosenCatalog?'selected':''}>${catalog}</option>`
                            })}
                        <select>
                        `:''}
                    </th>
                    <td class="CHOSEN_${chosenCatalog} ${manyCatalogs?'HAS_MANY_CATALOG':''}">
                        ${Object.keys(PRODUCTS).map((catalog)=>{
                            let productHTML = "" ;
                            let textHTMLCatalog = textHTML ;
                            if(block.catalogs && block.catalogs[catalog]){
                                let blockCatalog = block.catalogs[catalog] ;
                                if(blockCatalog.text){
                                    let textRendered = Mustache.render(blockCatalog.text, values);
                                    textHTMLCatalog += rho.toHtml(textRendered);
                                }
                                if(blockCatalog.products){
                                    var allowedProducts = PRODUCTS[catalog].removeNotAllowedProducts(blockCatalog.products, diag.input, this.data.hiddenProducts[catalog])
                                    allowedProducts.forEach(function(product){
                                        var filteredProduct = addQty([product], values) ;
                                        if(filteredProduct.length === 1){
                                            let productLabel = rho.toHtml(filteredProduct[0]) ;
                                            productHTML +=  `<div class="productEntry ${allowedProducts.length>1?'MANY': ''}">
                                                <div style="overflow: hidden;">
                                                <span class="name">${productLabel}</span> </div>
                                            </div>` ;
                                        }
                                    }) ;
                                }
                            }
                            return '<div class="CATALOG_'+catalog+'">'+productHTML + textHTMLCatalog+"</div>" ;
                        }).join("\n")}
                    </td>
                    </tr>`

                    replaces["@BLOCKS_" + pos + "@"] += blockHTML;

                }.bind(this)) ;

                var classes = createConditionalClasses(diag, values, plainBlocksAdded, replaces, this.data);
                replaces["@CLASSES@"] = classes ;
                
                reportHTML = Mustache.render(reportHTML, values);

                Object.keys(replaces).forEach(function (b) {
                    reportHTML = reportHTML.replace(b, replaces[b]);
                });



                done(null, {diag : diagData, reportHTML: reportHTML, mode: mode}) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

diagController.formController.openReport = function(diagData, mode, callback){
    if(!callback) { callback = function(){} ;}
    VeloxWebView.longTask(function(done){
        this.createReportHTML(diagData, mode, function(err, report){
            if(err){ return done(err) ;}
            this.navigate("report", report, "anonymous") ;
            done() ;
        }.bind(this)) ;
    }.bind(this), callback) ;
} ;


diagController.formController.updateMeasureFromSpin = function(measures){
    this.view.updateData() ;

    this.data.d_br = measures.bromine ;
    this.data.d_free_cl = measures.freeCl ;
    this.data.d_total_cl = measures.totalCl ;
    this.data.d_alk = measures.alk ;
    this.data.d_ph = measures.ph ;
    this.data.d_br = measures.bromine ;
    this.data.d_hardness = measures.hardness ;
    this.data.d_cu = measures.cu ;
    this.data.d_fe = measures.fe ;
    this.data.d_stab = measures.stab ;
    this.data.d_phosphate = measures.phosphate ;
    this.data.d_salt_disolved = measures.salt ;
    if(measures.signs){
        this.data.d_ph_sign        = measures.signs.ph;
        this.data.d_hardness_sign  = measures.signs.hardness;
        this.data.d_free_cl_sign   = measures.signs.freeCl;
        this.data.d_total_cl_sign  = measures.signs.totalCl;
        this.data.d_br_sign        = measures.signs.bromine;
        this.data.d_salt_sign      = measures.signs.salt;
        this.data.d_cu_sign        = measures.signs.cu;
        this.data.d_fe_sign        = measures.signs.fe;
        this.data.d_stab_sign      = measures.signs.stab;
        this.data.d_phosphate_sign = measures.signs.phosphate;
    }else{
        this.data.d_ph_sign        = null;
        this.data.d_hardness_sign  = null;
        this.data.d_free_cl_sign   = null;
        this.data.d_total_cl_sign  = null;
        this.data.d_br_sign        = null;
        this.data.d_salt_sign      = null;
        this.data.d_oxygen_sign    = null;
        this.data.d_cu_sign        = null;
        this.data.d_fe_sign        = null;
        this.data.d_stab_sign      = null;
        this.data.d_phosphate_sign = null;
    }
    this.view.render() ;
} ;


diagController.formController.onSpintouch = function(){
    var viewSpinlab = new VeloxWebView("views/diag", "popupSpinTouch", {bindObject: {}}) ;
    viewSpinlab.openInPopup({
        size:"medium",
        title: " "
    })  ;

    viewSpinlab.on("fetchResults",function(){
        viewSpinlab.updateData() ;
        this.view.longTask(function(done){
            bluetooth.getSpinlabBLEResults(function(err, measures){
                if(err){ 
                    if(err === "BT_NOT_ACTIVE"){
                        err = VeloxWebView.tr("diag.pleaseActivateBluetooth") ;
                    }
                    if(err === "MISSING_LOCATION_PERMISSION"){
                        err = VeloxWebView.tr("diag.pleaseActivateLocationService") ;
                    }
                    if(err === "NOT_FOUND"){
                        err = VeloxWebView.tr("diag.cantFindSpinTouch") ;
                    }
                    return done(err) ;
                }
                this.updateMeasureFromSpin(measures) ;
                viewSpinlab.close();
                done() ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
};

diagController.formController.onSpinlab = function(){
    this.view.longTask(function(done){
        this.view.updateData() ;
        this.api.api.velox_map.searchFirst({ code: "spinlabOptions", key: "spinlabOptions"}, function(err, mapResult){
            if(err){ return done(err) ;}
            done() ;
            var spinLabOptions = {} ;
            if(mapResult){
                spinLabOptions = mapResult.value ;
            }
            var viewSpinlab = new VeloxWebView("views/diag", "popupSpinlab", {bindObject: spinLabOptions}) ;
            viewSpinlab.openInPopup({
                size:"medium",
                title: " "
            })  ;
        
            function savePref(data, callback){
                var record = mapResult||{ code: "spinlabOptions", key: "spinlabOptions" };
                record.value = data;
                this.api.api.transactionalChanges([{action: mapResult?"update":"insert", table : "velox_map", record: record}], callback) ;
            } ;
        
            
            viewSpinlab.on("startDiag",function(){
                viewSpinlab.updateData() ;
                this.view.longTask(function(done){
                    savePref.bind(this)(spinLabOptions, function(err){
                        if(err){ return done(err) ;}
                        
                        var type = "";
                        var disinfectant = this.data.p_disinfectant ;
                        if(this.data.d_pool_or_spa === "SPA"){
                            disinfectant = this.data.s_disinfectant ;
                        }
                        if(disinfectant === "CHLORINE" || disinfectant === "OXYGEN"){
                            type = "chlorine" ;
                        }else if(disinfectant === "BROMINE") {
                            type = "bromine" ;
                        }else if(disinfectant === "SALT") {
                            type = "salt" ;
                        }

                        if(!type){
                            return done(this.view.tr("diag.error.pleaseChooseType"));
                        }
                        
                        window.native.spinlab.checkWlc(function(err){
                            if(err){
                                var message = err;
                                if(err === "MISSING_WLC"){
                                    message = VeloxWebView.tr("diag.shouldInstallWlc") ;
                                } else if(err === "SHOULD_UPDATE_WLC"){
                                    message = VeloxWebView.tr("diag.shouldUpdateWlc") ;
                                }
                                done();
                                return this.view.error(message, function(){
                                    window.native.spinlab.install() ;
                                }) ;
                            }
                            viewSpinlab.getBoundObject().running = true;
                            viewSpinlab.render();
                            window.native.spinlab.startAnalysis(type, spinLabOptions.disk, function(err, measures){
                                viewSpinlab.getBoundObject().running = false;
                                viewSpinlab.render();
                                if(err){ 
                                    if(err === "OFFLINE"){
                                        return done(this.view.tr("diag.error.OFFLINE")) ;
                                    } else if(err === "BUSY"){
                                        return done(this.view.tr("diag.error.BUSY")) ;
                                    } else if(err === "UPDATING"){
                                        return done(this.view.tr("diag.error.UPDATING")) ;
                                    } else if(err === "ERROR"){
                                        return done(this.view.tr("diag.error.ERROR")) ;
                                    } else if(err === "REQUIRES_UPDATE"){
                                        done() ;
                                        this.view.info(this.view.tr("diag.updateFirmware"), function(){
                                            this.view.longTask(function(done){
                                                viewSpinlab.getBoundObject().firmwareRunning = true;
                                                viewSpinlab.render();
                                                window.native.spinlab.updateFirmware(function(err){
                                                    viewSpinlab.getBoundObject().firmwareRunning = false;
                                                    viewSpinlab.render();
                                                    if(err){ return done(err) ; }
                                                    viewSpinlab.getBoundObject().running = true;
                                                    viewSpinlab.render();
                                                    window.native.spinlab.startAnalysis(type, spinLabOptions.disk, function(err, measures){
                                                        viewSpinlab.getBoundObject().running = false;
                                                        viewSpinlab.render();
                                                        if(err){
                                                            console.log("Spinlab error", err) ;
                                                            return done(this.view.tr("diag.spinlabError")) ;
                                                        }
                                                        this.updateMeasureFromSpin(measures) ;
                                                        viewSpinlab.close();
                                                        done() ;
                                                    }.bind(this)) ;
                                                }.bind(this)) ;
                                            }.bind(this)) ;
                                        }.bind(this)) ;
                                    } else {
                                        console.log("Spinlab error", err) ;
                                        return done(this.view.tr("diag.spinlabError")+"\n"+err) ;
                                    }
                                    return;
                                }
                                this.updateMeasureFromSpin(measures) ;
                                viewSpinlab.close();
                                done() ;
                            }.bind(this)) ;
                        }.bind(this)) ;
                    }.bind(this)) ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
};

module.exports = diagController ;